// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"120":"92c32542","138":"6d1ffc7b","567":"406a9aaf","613":"1054d192"}[chunkId] + ".chunk.js";
};